export const SimpleEnquiries = {
  '0': 'No Enquiry',
  '1': 'Lite (2-3 Sources)',
  '2': 'Standard (4-5 Sources)',
  '3': 'Extended (6-8 Sources)',
  '4': 'Enhanced (9+ Sources)'
};